import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.+im1ZA',
    defaultMessage: 'Blocks',
  },
  description: {
    id: 'studio.Z/h2/C',
    defaultMessage: 'Browse all blocks that are available within Appsemble',
  },
});
